import { defineMessages } from 'react-intl-next';

export default defineMessages({
    errorMessage: {
        defaultMessage: "We couldn't load this content. Refresh the page and try again.",
        description: 'Error message for when element content fails to load',
        id: 'cv.portal.customization.layout.primitives.element.error-message',
    },
});
